import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['member'],
  computed: {
    name: function name() {
      return "".concat(this.member.prenom, " ").concat(this.member.nom);
    }
  }
};